// extracted by mini-css-extract-plugin
export default {"TableHeader":"Insurances_TableHeader__OJpQ4","Icon":"Insurances_Icon__l44U6"};